import React from "react";
import { Box, Paper, Typography } from "@mui/material";

function GuideSection({ image, content }) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        p: { xs: 1.5, md: 2 },
        borderRadius: 2,
        border: "1px solid #e5edf5",
        bgcolor: "#ffffff",
      }}
    >
      <Box
        component="img"
        src={image}
        alt="Guide"
        sx={{
          width: "100%",
          display: "block",
          borderRadius: 2,
          border: "1px solid #e5edf5",
          mb: 1.5,
        }}
      />
      <Typography sx={{ color: "#07111f", lineHeight: 1.7 }}>
        {content}
      </Typography>
    </Paper>
  );
}

export default GuideSection;
